import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { v4 as uuid } from 'uuid';
import { ExcelFile, ExcelSheet, ExcelColumn } from 'react-xlsx-wrapper';
import CommonHeader from '../../../util_components/common_header';
import CustomModal from '../../../util_components/custom_modal';
import CustomSingleSelect from '../../../util_components/custom_single_select';
import CustomDatePicker from '../../../util_components/custom_date_picker';

import {
  image_error_replace,
  getCookie,
  get_date_filter_data_timezone_utc
} from '../../../../util_functions';
import {
  day_format,
  time_format,
  date_drop_for_report,
  iana_values,
  trial_end_date_drop_for_report,
  newUsersDownloadList,
  EthnicityOptions
} from '../../../../constants';
import { post_api, put_api } from '../../../../redux/api_funcs';
import * as actions from '../../../../redux/action_creators';
import { get_api_url } from '../../../../utils/urls';
import SmsWindow from '../sms_window';

import 'react-datepicker/dist/react-datepicker.css';
import Button from '../../../util_components/button';
import Single_teacher_availability from '../../teachers/single_teacher_availability';

import UserRole from '../../../../../myt_chat/src/chat/enums/UserRole';
import { openChatWithUserUUID } from '../../../chat/chat';
import { EditIcon } from '../../../../utils/svg';

import './styles.css';

class ConciergeV2 extends Component {
  state = {
    loading: true,
    start_date: moment().format('YYYY-MM-DD'),
    end_date: moment().format('YYYY-MM-DD'),
    start_date_for_trial: moment().format('YYYY-MM-DD'),
    end_date_for_trial: moment().format('YYYY-MM-DD'),
    students: [],
    history: '',
    history_open: '',
    open_info: false,
    student_info: {},
    concierge_teachers: [],
    concierge_teacher_uuid: 'all',
    selected_iana_timezone: 'ALL',
    is_header_sticky: false,
    sms_window_open: false,
    sms_student: '',
    sms_student_name: '',
    is_sorted: false,
    show_concierge_detail: false,
    s_uuid: '',
    concierge_detail: '',
    on_boarding_sort: -1,
    active_score_sort: -1,
    show_arrow: false,
    show_activity_score_arrow: false,
    onboarding_score_for_popup: '',
    iana_abbr_list: [],
    is_back_pain_client: 0,
    original_message_uuid: '',
    show_teacher_popup: false,
    teachers_list: [],
    teachers_loaded: false,
    change_teacher_id: '',
    consult_session_uuid: '',
    filtered_consultant_list: [],
    selected_consultant_uuid: 'all',
    date_filter_type: 'TODAY',
    trial_end_date_filter: '',
    open_ethnicity_popup: false,
    concierge_entered_ethnicity: '',
    message_dispatch_method: '',
    is_allowed_whatsapp: false,
    is_allowed_sms: false,
    activeTab: 'all'
  };

  headerRef = React.createRef();

  async componentDidMount() {
    this.load_data();

    if (this.props.teachers_list_status === 'success') {
      this.set_teachers_list();
    }

    if (this.props.teachers_list_status === 'none') {
      this.props.get_teachers_list();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.teachers_list_status === 'loading' &&
      this.props.teachers_list_status === 'success'
    ) {
      this.set_teachers_list();
    }
  }

  set_teachers_list = () => {
    const all_teachers = this.props.teachers_list.filter((t) => t.opt_in_concierge === 1);
    const teachers_list = all_teachers.map((teacher) => ({
      value: teacher.uuid,
      label: `${teacher.first_name} ${teacher.last_name}`
    }));

    teachers_list.sort((a, b) => a.label.localeCompare(b.label));
    this.setState({
      concierge_teachers: [{ value: 'all', label: 'ALL' }, ...teachers_list],
      show_arrow: false,
      show_activity_score_arrow: false,
      on_boarding_sort: -1,
      active_score_sort: -1
    });
  };

  load_data = () =>
    this.setState({ loading: true, students: [] }, () => {
      const {
        date_filter_type,
        start_date,
        end_date,
        is_back_pain_client,
        trial_end_date_filter,
        end_date_for_trial,
        start_date_for_trial
      } = this.state;
      const url = get_api_url('get_concierge_students');
      let date_data;
      if (trial_end_date_filter !== '') {
        date_data = get_date_filter_data_timezone_utc(
          trial_end_date_filter,
          start_date_for_trial,
          end_date_for_trial
        );
      } else if (date_filter_type !== '') {
        date_data = get_date_filter_data_timezone_utc(date_filter_type, start_date, end_date);
      }

      const payload = {
        start_date: date_data.utc_start_date,
        end_date: date_data.utc_end_date,
        iana_timezone: this.props.iana_timezone,
        is_back_pain_client,
        get_by_trial_end_date: trial_end_date_filter !== '' ? 1 : 0
      };
      post_api(url, payload, true)
        .then((res) => {
          this.setState(
            {
              students: [...res.data.student_data],
              iana_abbr_list: [...res.data.iana_abbr_list],
              show_arrow: false,
              show_activity_score_arrow: false,
              on_boarding_sort: -1,
              active_score_sort: -1
            },
            () => {
              this.setState({ loading: false });
            }
          );
        })
        .catch((e) => {
          let err_message;
          try {
            err_message = e.response.data.message;
          } catch (err) {
            err_message = 'Some error occurred. Please contact dev team.';
          }
          this.props.set_notification_variable(true, 'error', err_message);
          this.setState({ loading: false });
        });
    });

  handle_date_change = (name, val) => this.setState({ [name]: val });

  change_date_filter = (e) =>
    this.setState(
      { date_filter_type: e.target.value, students: [], trial_end_date_filter: '' },
      () => {
        this.load_data();
      }
    );

  change_trial_end_date_filter = (e) => {
    this.setState(
      { trial_end_date_filter: e.target.value, students: [], date_filter_type: '' },
      () => {
        this.load_data();
      }
    );
  };

  change_concierge = (e) => {
    this.setState({ concierge_teacher_uuid: e.target.value });
  };

  change_iana_timezone = (e) => {
    this.setState({ selected_iana_timezone: e.target.value });
  };

  clear_concierge = () => this.setState({ concierge_teacher_uuid: 'all' });

  clear_timezone = () => this.setState({ selected_iana_timezone: 'ALL' });

  clear_trial_end_date = () => this.setState({ trial_end_date_filter: '' });

  clear_onboarding_date = () => this.setState({ date_filter_type: '' });

  load_concierge_data = () => {
    this.setState({ loading: true }, () => {
      const { s_uuid } = this.state;
      const url = get_api_url('get_concierge_onboarding_score_details');
      const payload = { student_uuid: s_uuid };
      post_api(url, payload, true)
        .then((res) => {
          this.setState({ loading: false, concierge_detail: res.data });
        })
        .catch((e) => {
          let err_message;
          try {
            err_message = e.response.data.message;
          } catch (err) {
            err_message = 'Some error occurred. Please contact dev team.';
          }
          this.props.set_notification_variable(true, 'error', err_message);
          this.setState({ loading: false });
        });
    });
  };

  open_concierge_detail = (student_uuid, onboarding_score) => {
    this.setState({
      show_concierge_detail: true,
      s_uuid: student_uuid,
      onboarding_score_for_popup: onboarding_score
    });
    this.load_concierge_data();
  };

  close_concierge_detail = () => {
    this.setState({ show_concierge_detail: false });
  };

  sort_student_data = () => {
    const { students, on_boarding_sort } = this.state;
    const sorted_students = [...students];
    sorted_students.sort((a, b) => {
      if (on_boarding_sort === 1) {
        return a.onboarding_score - b.onboarding_score;
      }
      return b.onboarding_score - a.onboarding_score;
    });
    this.setState({
      students: sorted_students,
      on_boarding_sort: on_boarding_sort === 1 ? -1 : 1,
      show_arrow: true,
      show_activity_score_arrow: false
    });
  };

  sort_activity_score = () => {
    const { students, active_score_sort } = this.state;
    const sorted_students = [...students];
    sorted_students.sort((a, b) => {
      if (active_score_sort === 1) {
        return a.activity_score - b.activity_score;
      }
      return b.activity_score - a.activity_score;
    });
    this.setState({
      students: sorted_students,
      active_score_sort: active_score_sort === 1 ? -1 : 1,
      show_activity_score_arrow: true,
      show_arrow: false
    });
  };

  open_history = (e, history) => {
    e.preventDefault();
    this.setState({ history_open: true, history });
  };

  close_history = () => this.setState({ history_open: false, open_info: false, student_info: {} });

  open_sms_window = (student) => {
    this.setState({
      sms_window_open: true,
      sms_student: student.uuid,
      sms_student_name: student.name,
      original_message_uuid: student.sms_uuid,
      message_dispatch_method: student.message_dispatch_method,
      is_allowed_whatsapp: student.is_allowed_whatsapp,
      is_allowed_sms: student.is_allowed_sms
    });
  };

  close_sms_window = () => this.setState({ sms_window_open: false, sms_student: '' });

  on_reply_sent = () => {
    const { students, sms_student } = this.state;
    const new_students_data = [...students];
    const student = new_students_data.find((s) => s.uuid === sms_student);
    if (student) {
      student.to_student = 1;
      this.setState({ students: new_students_data });
    }
  };

  open_chat = (student) => {
    openChatWithUserUUID(student.uuid, UserRole.STUDENT, `${student.name}`);
  };

  open_ethnicity_popup = (student) => {
    this.setState({
      open_ethnicity_popup: true,
      student_info: student,
      concierge_entered_ethnicity: student.concierge_entered_ethnicity
    });
  };

  close_ethnicity_popup = () => {
    this.setState({ open_ethnicity_popup: false });
  };

  change_ethnicity_value = (e) => {
    e.preventDefault();
    this.setState({ concierge_entered_ethnicity: e.target.value });
  };

  submit_entered_ethnicity = async () => {
    this.setState({ loading: true });
    const url = get_api_url('/v2/cms_user/update_student_ethnicity', false, true);
    const payload = {
      student_uuid: this.state.student_info?.uuid,
      ethnicity: this.state.concierge_entered_ethnicity
    };
    try {
      await put_api(url, payload, true);
      this.setState({ loading: false });
      this.load_data();
      this.close_ethnicity_popup();
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  get_excel_data = (students) =>
    students.map((student) => ({
      ...student,
      created_date: moment(student.created_date)
        .tz(this.props.iana_timezone)
        .format('YYYY-MM-DD HH:mm:ss'),
      trial_end_date: moment(student.trial_end_date)
        .tz(this.props.iana_timezone)
        .format('YYYY-MM-DD HH:mm:ss')
    }));

  getFilteredStudents = () => {
    const { students, concierge_teacher_uuid, selected_iana_timezone, activeTab } = this.state;

    let filtered = students.filter((s) => {
      if (concierge_teacher_uuid === 'all') {
        return !!s.concierge_uuid;
      }
      return s.concierge_uuid === concierge_teacher_uuid;
    });

    if (selected_iana_timezone !== 'ALL') {
      filtered = filtered.filter((s) => s.iana_abbr === selected_iana_timezone);
    }

    // Tab filtering
    if (activeTab === 'members') {
      filtered = filtered.filter((s) => s.is_member === 1);
    } else if (activeTab === 'non-members') {
      filtered = filtered.filter((s) => s.is_member !== 1);
    } else if (activeTab === 'replied') {
      filtered = filtered.filter((s) => s.to_student === 1);
    } else if (activeTab === 'not-replied') {
      filtered = filtered.filter((s) => s.to_student !== 1);
    }

    return filtered;
  };

  getStats = () => {
    const students = this.getFilteredStudents();
    const totalStudents = students.length;
    const members = students.filter((s) => s.is_member === 1).length;
    const nonMembers = totalStudents - members;
    const replied = students.filter((s) => s.to_student === 1).length;
    const notReplied = totalStudents - replied;
    const avgOnboardingScore =
      totalStudents > 0
        ? (students.reduce((sum, s) => sum + (s.onboarding_score || 0), 0) / totalStudents).toFixed(
            1
          )
        : 0;
    const avgActivityScore =
      totalStudents > 0
        ? (students.reduce((sum, s) => sum + (s.activity_score || 0), 0) / totalStudents).toFixed(1)
        : 0;

    return {
      totalStudents,
      members,
      nonMembers,
      replied,
      notReplied,
      avgOnboardingScore,
      avgActivityScore,
      conversionRate: totalStudents > 0 ? ((members / totalStudents) * 100).toFixed(1) : 0
    };
  };

  render_filters = () => {
    const {
      date_filter_type,
      start_date,
      end_date,
      concierge_teachers,
      concierge_teacher_uuid,
      selected_iana_timezone,
      iana_abbr_list,
      trial_end_date_filter,
      start_date_for_trial,
      end_date_for_trial
    } = this.state;

    return (
      <div className="cv2-filters">
        <div className="cv2-filters-row">
          <div className="cv2-filter-group">
            <CustomSingleSelect
              label="Trial Start Date"
              options={date_drop_for_report}
              onChange={this.change_date_filter}
              value={date_filter_type}
              style={{ width: '180px' }}
              showClear
              clear_fn={this.clear_onboarding_date}
              defaultOptionDisabled={trial_end_date_filter !== ''}
            />
          </div>
          <div className="cv2-filter-group">
            <CustomSingleSelect
              label="Trial End Date"
              options={trial_end_date_drop_for_report}
              onChange={this.change_trial_end_date_filter}
              value={trial_end_date_filter}
              showClear
              style={{ width: '180px' }}
              clear_fn={this.clear_trial_end_date}
              defaultOptionDisabled={date_filter_type !== ''}
            />
          </div>
          {(date_filter_type === 'CUSTOM' || trial_end_date_filter === 'CUSTOM') && (
            <div className="cv2-filter-group cv2-date-range">
              <div className="cv2-date-range-indicator" />
              <CustomDatePicker
                label="Start"
                value={date_filter_type === 'CUSTOM' ? start_date : start_date_for_trial}
                handleChange={(val) =>
                  this.handle_date_change(
                    date_filter_type === 'CUSTOM' ? 'start_date' : 'start_date_for_trial',
                    val
                  )
                }
                maxDate={date_filter_type === 'CUSTOM' ? end_date : end_date_for_trial}
              />
              <CustomDatePicker
                label="End"
                value={date_filter_type === 'CUSTOM' ? end_date : end_date_for_trial}
                handleChange={(val) =>
                  this.handle_date_change(
                    date_filter_type === 'CUSTOM' ? 'end_date' : 'end_date_for_trial',
                    val
                  )
                }
                minDate={date_filter_type === 'CUSTOM' ? start_date : start_date_for_trial}
              />
              <button className="cv2-btn cv2-btn-primary cv2-btn-sm" onClick={this.load_data}>
                Apply
              </button>
            </div>
          )}
        </div>
        <div className="cv2-filters-row">
          <div className="cv2-filter-group">
            <CustomSingleSelect
              label="Concierge"
              options={concierge_teachers}
              onChange={this.change_concierge}
              value={concierge_teacher_uuid}
              style={{ width: '180px' }}
              showClear
              clear_fn={this.clear_concierge}
            />
          </div>
          <div className="cv2-filter-group">
            <CustomSingleSelect
              label="Timezone"
              options={iana_abbr_list}
              onChange={this.change_iana_timezone}
              value={selected_iana_timezone}
              style={{ width: '180px' }}
              showClear
              clear_fn={this.clear_timezone}
            />
          </div>
        </div>
      </div>
    );
  };

  render_stats = () => {
    const stats = this.getStats();

    return (
      <div className="cv2-stats-grid">
        <div className="cv2-stat-card">
          <div className="cv2-stat-row">
            <div className="cv2-stat-icon cv2-stat-icon-primary">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>
            </div>
            <span className="cv2-stat-value">{stats.totalStudents}</span>
          </div>
          <span className="cv2-stat-label">Total Students</span>
        </div>

        <div className="cv2-stat-card">
          <div className="cv2-stat-row">
            <div className="cv2-stat-icon cv2-stat-icon-success">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
                <polyline points="22 4 12 14.01 9 11.01" />
              </svg>
            </div>
            <span className="cv2-stat-value">{stats.members}</span>
          </div>
          <span className="cv2-stat-label">Members</span>
        </div>

        <div className="cv2-stat-card">
          <div className="cv2-stat-row">
            <div className="cv2-stat-icon cv2-stat-icon-warning">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 6v6l4 2" />
              </svg>
            </div>
            <span className="cv2-stat-value">{stats.nonMembers}</span>
          </div>
          <span className="cv2-stat-label">Non-Members</span>
        </div>

        <div className="cv2-stat-card">
          <div className="cv2-stat-row">
            <div className="cv2-stat-icon cv2-stat-icon-info">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
              </svg>
            </div>
            <span className="cv2-stat-value">{stats.replied}</span>
          </div>
          <span className="cv2-stat-label">Replied</span>
        </div>

        <div className="cv2-stat-card">
          <div className="cv2-stat-row">
            <div className="cv2-stat-icon cv2-stat-icon-danger">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="15" y1="9" x2="9" y2="15" />
                <line x1="9" y1="9" x2="15" y2="15" />
              </svg>
            </div>
            <span className="cv2-stat-value">{stats.notReplied}</span>
          </div>
          <span className="cv2-stat-label">Not Replied</span>
        </div>

        <div className="cv2-stat-card">
          <div className="cv2-stat-row">
            <div className="cv2-stat-icon cv2-stat-icon-purple">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 20V10" />
                <path d="M18 20V4" />
                <path d="M6 20v-4" />
              </svg>
            </div>
            <span className="cv2-stat-value">{stats.avgOnboardingScore}</span>
          </div>
          <span className="cv2-stat-label">Avg. Onboarding</span>
        </div>
      </div>
    );
  };

  render_tabs = () => {
    const { activeTab } = this.state;
    const stats = this.getStats();

    const tabs = [
      { id: 'all', label: 'All', count: stats.totalStudents },
      { id: 'members', label: 'Members', count: stats.members },
      { id: 'non-members', label: 'Non-Members', count: stats.nonMembers },
      { id: 'replied', label: 'Replied', count: stats.replied },
      { id: 'not-replied', label: 'Not Replied', count: stats.notReplied }
    ];

    return (
      <div className="cv2-tabs">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            className={`cv2-tab ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => this.setState({ activeTab: tab.id })}
          >
            {tab.label}
            <span className="cv2-tab-count">{tab.count}</span>
          </button>
        ))}
      </div>
    );
  };

  render_toolbar = () => {
    const { on_boarding_sort, show_arrow, active_score_sort, show_activity_score_arrow } =
      this.state;
    const filter_students = this.getFilteredStudents();
    const file_name = `concierge_students_${moment().format('YYYY-MM-DD_HH-mm')}`;

    return (
      <div className="cv2-toolbar">
        <div className="cv2-toolbar-left">
          <span className="cv2-toolbar-count">
            Showing <strong>{filter_students.length}</strong> students
          </span>
        </div>
        <div className="cv2-toolbar-right">
          <div className="cv2-sort-group">
            <span className="cv2-sort-label">Sort by:</span>
            <button
              className={`cv2-sort-btn ${show_arrow ? 'active' : ''}`}
              onClick={this.sort_student_data}
            >
              Onboarding
              {show_arrow && (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  {on_boarding_sort === 1 ? (
                    <path d="M18 15l-6-6-6 6" />
                  ) : (
                    <path d="M6 9l6 6 6-6" />
                  )}
                </svg>
              )}
            </button>
            <button
              className={`cv2-sort-btn ${show_activity_score_arrow ? 'active' : ''}`}
              onClick={this.sort_activity_score}
            >
              Activity
              {show_activity_score_arrow && (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  {active_score_sort === 1 ? (
                    <path d="M18 15l-6-6-6 6" />
                  ) : (
                    <path d="M6 9l6 6 6-6" />
                  )}
                </svg>
              )}
            </button>
          </div>
          <ExcelFile
            element={
              <button className="cv2-btn cv2-btn-success cv2-btn-sm">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" y1="15" x2="12" y2="3" />
                </svg>
                Export
              </button>
            }
            filename={file_name}
          >
            <ExcelSheet data={this.get_excel_data(filter_students)} name="Concierge Students">
              {newUsersDownloadList.map((d) => (
                <ExcelColumn label={d.label} value={d.value} key={d.value} />
              ))}
            </ExcelSheet>
          </ExcelFile>
        </div>
      </div>
    );
  };

  render_student_card = (student, index) => {
    const student_url = `/studentprofile?id=${student.uuid}`;
    const concierge_url = `/teacherprofile?id=${student.concierge_uuid}`;
    const ethnicity =
      student.concierge_entered_ethnicity !== ''
        ? student.concierge_entered_ethnicity
        : student.ml_ethnicity;

    return (
      <div className="cv2-card" key={index + student.uuid}>
        {/* Header Section */}
        <div className="cv2-card-header">
          <a className="cv2-user-link" href={student_url} target="_blank" rel="noopener noreferrer">
            <img
              src={student.profile_photo}
              onError={image_error_replace}
              alt=""
              className="cv2-avatar"
            />
            <div className="cv2-user-info">
              <div className="cv2-user-name-row">
                <span className="cv2-user-name">{student.name}</span>
                <button
                  className="cv2-icon-btn cv2-icon-btn-info"
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ open_info: true, student_info: student });
                  }}
                >
                  i
                </button>
              </div>
              <div className="cv2-user-meta">
                {student.yoga_level && <span className="cv2-user-level">{student.yoga_level}</span>}
                {student.yoga_level && ethnicity && <span className="cv2-user-separator">|</span>}
                {ethnicity && (
                  <span className="cv2-user-ethnicity">
                    {ethnicity}
                    <button
                      className="cv2-icon-btn cv2-icon-btn-edit cv2-icon-btn-inline"
                      onClick={(e) => {
                        e.preventDefault();
                        this.open_ethnicity_popup(student);
                      }}
                    >
                      {EditIcon()}
                    </button>
                  </span>
                )}
              </div>
              <span className="cv2-user-timezone">{student.iana_timezone}</span>
            </div>
          </a>
          <div className="cv2-header-right">
            <div className="cv2-card-badges">
              {student.is_member === 1 ? (
                <span className="cv2-badge cv2-badge-success">Member</span>
              ) : (
                <span className="cv2-badge cv2-badge-warning">Trial</span>
              )}
              {student.to_student === 1 && (
                <span className="cv2-badge cv2-badge-info">Replied</span>
              )}
            </div>
            <div className="cv2-info-item cv2-info-item-row">
              <span className="cv2-info-label">Credits</span>
              <span className="cv2-info-value cv2-info-value-primary">{student.credits}</span>
            </div>
            <div className="cv2-concierge-row">
              {student.concierge_uuid ? (
                <a
                  className="cv2-link"
                  href={concierge_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {student.concierge_name}
                </a>
              ) : (
                <span className="cv2-info-value cv2-info-value-muted">
                  {student.concierge_name || 'Unassigned'}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Content Grid */}
        <div className="cv2-card-body">
          {/* Row 1: Trial Dates */}
          <div className="cv2-info-row cv2-info-row-2col">
            <div className="cv2-info-item">
              <span className="cv2-info-label">Trial Start</span>
              <span className="cv2-info-value">
                {moment(student.created_date).tz(this.props.iana_timezone).format('MMM D, h:mm A')}
              </span>
            </div>
            <div className="cv2-info-item">
              <span className="cv2-info-label">Trial End</span>
              <span className="cv2-info-value cv2-info-value-danger">
                {moment(student.trial_end_date)
                  .tz(this.props.iana_timezone)
                  .format('MMM D, h:mm A')}
              </span>
            </div>
          </div>

          {/* Row 2: Scores */}
          <div className="cv2-info-row cv2-info-row-2col">
            <div className="cv2-info-item cv2-info-item-score">
              <span className="cv2-info-label">Onboarding</span>
              <div className="cv2-score-with-info">
                <span className="cv2-score-value">{student.onboarding_score}</span>
                <button
                  className="cv2-icon-btn cv2-icon-btn-info"
                  onClick={() => this.open_concierge_detail(student.uuid, student.onboarding_score)}
                >
                  i
                </button>
              </div>
            </div>
            <div className="cv2-info-item cv2-info-item-score">
              <span className="cv2-info-label">Activity</span>
              <span className="cv2-score-value">{student.activity_score}</span>
            </div>
          </div>

          {/* Row 4: Sessions */}
          <div className="cv2-sessions-row">
            <div className="cv2-sessions-group">
              <span className="cv2-sessions-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Finished
              </span>
              <div className="cv2-sessions-values">
                <div className="cv2-session-stat">
                  <span className="cv2-session-type">1on1</span>
                  {student.yoga_sessions_finshed > 0 ? (
                    <a
                      className="cv2-session-count cv2-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`/usersessions/past?id=${student.uuid}&user_type=STUDENT&name=${student.name}`}
                    >
                      {student.yoga_sessions_finshed}
                    </a>
                  ) : (
                    <span className="cv2-session-count">0</span>
                  )}
                </div>
                <div className="cv2-session-stat">
                  <span className="cv2-session-type">Group</span>
                  {student.group_sessions_finshed > 0 ? (
                    <a
                      className="cv2-session-count cv2-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`/usersessions/past?id=${student.uuid}&user_type=STUDENT&name=${student.name}`}
                    >
                      {student.group_sessions_finshed}
                    </a>
                  ) : (
                    <span className="cv2-session-count">0</span>
                  )}
                </div>
              </div>
            </div>
            <div className="cv2-sessions-group">
              <span className="cv2-sessions-label">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 6v6l4 2" />
                </svg>
                Scheduled
              </span>
              <div className="cv2-sessions-values">
                <div className="cv2-session-stat">
                  <span className="cv2-session-type">1on1</span>
                  {student.yoga_sessions_scheduled > 0 ? (
                    <a
                      className="cv2-session-count cv2-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`/usersessions/future?id=${student.uuid}&user_type=STUDENT&name=${student.name}`}
                    >
                      {student.yoga_sessions_scheduled}
                    </a>
                  ) : (
                    <span className="cv2-session-count">0</span>
                  )}
                </div>
                <div className="cv2-session-stat">
                  <span className="cv2-session-type">Group</span>
                  {student.group_sessions_scheduled > 0 ? (
                    <a
                      className="cv2-session-count cv2-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`/usersessions/future?id=${student.uuid}&user_type=STUDENT&name=${student.name}`}
                    >
                      {student.group_sessions_scheduled}
                    </a>
                  ) : (
                    <span className="cv2-session-count">0</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Actions */}
        <div className="cv2-card-footer">
          <button
            className="cv2-action-btn cv2-action-btn-chat"
            onClick={() => this.open_chat(student)}
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
            Chat
          </button>
          {!!student.phone_no &&
            student.phone_no !== '' &&
            student.message_dispatch_method !== 'none' && (
              <button
                className={`cv2-action-btn ${student.message_dispatch_method === 'whatsapp' ? 'cv2-action-btn-whatsapp' : 'cv2-action-btn-sms'}`}
                onClick={() => this.open_sms_window(student)}
              >
                {student.message_dispatch_method === 'whatsapp' ? (
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                )}
                {student.message_dispatch_method === 'sms' ? 'SMS' : 'WhatsApp'}
              </button>
            )}
        </div>
      </div>
    );
  };

  render_concierge_profile = () => {
    const { concierge_detail, onboarding_score_for_popup } = this.state;
    return (
      <div className="cv2-modal-content">
        <h3 className="cv2-modal-title">Onboarding Score Breakdown</h3>
        <div className="cv2-score-breakdown">
          <div className="cv2-score-total">
            <span className="cv2-score-total-label">Total Score</span>
            <span className="cv2-score-total-value">{onboarding_score_for_popup}</span>
          </div>
          <div className="cv2-score-items">
            <div className="cv2-score-item">
              <span className="cv2-score-item-label">Ethnicity (Western: 1, Indian: 2)</span>
              <span className="cv2-score-item-value">{concierge_detail.ethnicity_score}</span>
            </div>
            <div className="cv2-score-item">
              <span className="cv2-score-item-label">
                Yoga Level (Newbie/Beginner: 1, Intermediate/Advanced: 2)
              </span>
              <span className="cv2-score-item-value">{concierge_detail.yoga_level_score}</span>
            </div>
            <div className="cv2-score-item">
              <span className="cv2-score-item-label">Learner Type (Group: 1, One-on-One: 1.5)</span>
              <span className="cv2-score-item-value">{concierge_detail.learner_type_score}</span>
            </div>
            <div className="cv2-score-item">
              <span className="cv2-score-item-label">
                Funnel (Referral: 4, Organic: 3, Paid: 1)
              </span>
              <span className="cv2-score-item-value">{concierge_detail.funnel_score}</span>
            </div>
            <div className="cv2-score-item">
              <span className="cv2-score-item-label">Gender (Male: 1.25, Female: 1)</span>
              <span className="cv2-score-item-value">{concierge_detail.gender_score}</span>
            </div>
            <div className="cv2-score-item">
              <span className="cv2-score-item-label">
                Signup Time (7am-7pm in user timezone: 1, Else: 0.5)
              </span>
              <span className="cv2-score-item-value">{concierge_detail.signup_time_score}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render_info = () => {
    const { student_info } = this.state;
    return (
      <div className="cv2-modal-content">
        <h3 className="cv2-modal-title">Student Information</h3>
        <div className="cv2-info-list">
          <div className="cv2-info-list-item">
            <span className="cv2-info-list-label">Name</span>
            <span className="cv2-info-list-value">{student_info.name || 'N/A'}</span>
          </div>
          <div className="cv2-info-list-item">
            <span className="cv2-info-list-label">Health History</span>
            <span className="cv2-info-list-value">{student_info.health_history || 'N/A'}</span>
          </div>
          <div className="cv2-info-list-item">
            <span className="cv2-info-list-label">Funnel Type</span>
            <span className="cv2-info-list-value">{student_info.funnel_type || 'N/A'}</span>
          </div>
          <div className="cv2-info-list-item">
            <span className="cv2-info-list-label">Funnel URL</span>
            <span className="cv2-info-list-value">{student_info.funnel_url || 'N/A'}</span>
          </div>
          <div className="cv2-info-list-item">
            <span className="cv2-info-list-label">Offer Type</span>
            <span className="cv2-info-list-value">{student_info.offer_type || 'N/A'}</span>
          </div>
          <div className="cv2-info-list-item">
            <span className="cv2-info-list-label">Affiliate</span>
            <span className="cv2-info-list-value">{student_info.affiliate || 'N/A'}</span>
          </div>
        </div>
      </div>
    );
  };

  render_change_ethnicity = () => (
    <div className="cv2-modal-content">
      <h3 className="cv2-modal-title">Update Ethnicity</h3>
      <div className="cv2-form-group">
        <CustomSingleSelect
          label="Ethnicity"
          options={EthnicityOptions}
          onChange={(e) => this.change_ethnicity_value(e)}
          value={this.state.concierge_entered_ethnicity}
          name="concierge_entered_ethnicity"
        />
      </div>
      <div className="cv2-form-actions">
        <button className="cv2-btn cv2-btn-primary" onClick={() => this.submit_entered_ethnicity()}>
          Save Changes
        </button>
        <button className="cv2-btn cv2-btn-secondary" onClick={this.close_ethnicity_popup}>
          Cancel
        </button>
      </div>
    </div>
  );

  render() {
    const {
      loading,
      history_open,
      history,
      open_info,
      sms_window_open,
      sms_student,
      sms_student_name,
      show_concierge_detail,
      original_message_uuid,
      open_ethnicity_popup,
      student_info,
      message_dispatch_method,
      is_allowed_sms,
      is_allowed_whatsapp
    } = this.state;

    const filter_students = this.getFilteredStudents();

    return (
      <CommonHeader loading={loading} title="Concierge Dashboard v2">
        <div className="cv2-container">
          {/* Filters Section */}
          <div className="cv2-section">
            <div className="cv2-section-header">
              <h2 className="cv2-section-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                </svg>
                Filters
              </h2>
            </div>
            {this.render_filters()}
          </div>

          {/* Stats Dashboard */}
          <div className="cv2-section">
            <div className="cv2-section-header">
              <h2 className="cv2-section-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M12 20V10" />
                  <path d="M18 20V4" />
                  <path d="M6 20v-4" />
                </svg>
                Overview
              </h2>
            </div>
            {this.render_stats()}
          </div>

          {/* Tabs & Students List */}
          <div className="cv2-section cv2-section-main">
            <div className="cv2-section-header">
              <h2 className="cv2-section-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
                Students
              </h2>
              {this.render_tabs()}
            </div>
            {this.render_toolbar()}
            <div className="cv2-cards-grid">
              {filter_students.map(this.render_student_card)}
              {filter_students.length === 0 && (
                <div className="cv2-empty-state">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <path d="M16 16s-1.5-2-4-2-4 2-4 2" />
                    <line x1="9" y1="9" x2="9.01" y2="9" />
                    <line x1="15" y1="9" x2="15.01" y2="9" />
                  </svg>
                  <h3>No students found</h3>
                  <p>Try adjusting your filters to see more results.</p>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Modals */}
        <CustomModal show={history_open} close={this.close_history}>
          <div className="cv2-modal-content">
            <h3 className="cv2-modal-title">Health History</h3>
            <div className="cv2-health-history">{history}</div>
          </div>
        </CustomModal>

        <CustomModal show={open_info} close={this.close_history}>
          {this.render_info()}
        </CustomModal>

        <CustomModal show={show_concierge_detail} close={this.close_concierge_detail}>
          {this.render_concierge_profile()}
        </CustomModal>

        <CustomModal show={open_ethnicity_popup} close={this.close_ethnicity_popup}>
          {this.render_change_ethnicity()}
        </CustomModal>

        {sms_window_open && (
          <SmsWindow
            student_uuid={sms_student}
            student_name={sms_student_name}
            original_message_uuid={original_message_uuid}
            close_fn={this.close_sms_window}
            send_success_notification={this.on_reply_sent}
            message_dispatch_method={message_dispatch_method}
            is_allowed_whatsapp={is_allowed_whatsapp}
            is_allowed_sms={is_allowed_sms}
          />
        )}
      </CommonHeader>
    );
  }
}

const mapStateToProps = (state) => ({
  iana_timezone: state.home.iana_timezone,
  teachers_list: state.teachers.teachers_list,
  teachers_list_status: state.teachers.teachers_list_status
});

const mapDispatchToProps = (dispatch) => ({
  get_teachers_list: (status) => {
    dispatch(actions.get_teachers_list(status));
  },
  set_notification_variable: (show, type, mes) => {
    dispatch(actions.set_notification_variable(show, type, mes));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ConciergeV2);
